<template>
  <!-- NOTE (TEMPLATE) to show the proposal page -->

  <div>
    <!-- loading component -->
    <Loading />
    <MasterProposal role="manager" />
  </div>
</template>

<script>
const MasterProposal = () => import("../../components/MasterProposal");

export default {
  components: {
    MasterProposal // NOTE (COMPONENT) component of proposal
  },
  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
